import { Controller } from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  loadComplete() {
    // Format the time in browser timezone after loading another pagefull
    $(document).trigger('simplero:section:load')
  }
}
